import { FC, useEffect, useState } from "react"
import BBDialog from "../../dialog"
import { ManageEngagementPanel } from "../../engagements"

interface Props {
  brandId?: string
  leadId?: string
  onCancel: () => void
}

const PushToEngagements: FC<Props> = ({ brandId, leadId, onCancel }) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const closeDialog = () => setDialogOpen(false)
  const cancelDialog = () => {
    closeDialog()
    onCancel()
  }

  useEffect(() => {
    if (leadId) setDialogOpen(true)
  }, [leadId])

  return (
    <>
      <BBDialog
        open={dialogOpen}
        title="Create engagement from a lead"
        body="A new Engagement will be created from this lead in order to enroll this lead to rate alerts, create dashboards and to download loan estimates. "
        theme="info"
        okLabel="Yes, proceed"
        cancelLabel="Cancel"
        onOk={closeDialog}
        onClose={cancelDialog}
        onCancel={cancelDialog}
      />

      <ManageEngagementPanel
        brandId={brandId}
        open={!!leadId && !dialogOpen}
        leadId={leadId}
        onClose={onCancel}
      />
    </>
  )
}

export default PushToEngagements
